module.exports = __webpack_public_path__ + "static/media/about-img1-mobile.ff94f251.svg";